import { assign } from 'lodash'

import { BaseDto } from "./base.dto"
import { DateOfBirthDto } from "./date-of-birth.dto"
import { PagingDto } from "./paging.dto"
import { UserDto } from "./user.dto"
import { MallOrderDto } from "./mall-order.dto"
import { MallCouponSource } from "./mall-coupon.dto"

export class CreateMallVoucherDto {
  ownerIds?: string
  khmerTitle: string
  englishTitle: string
  amount: number
  minOrder: number
  maxOrder: number
  discountType: string
  productType?: string
  givenType: string
  limitUsage?: number
  startDate: DateOfBirthDto
  endDate: DateOfBirthDto
  mallId?: string
  tenantId: string
  type: string
  minTenant: number
  maxTenant: number

  static create() {
    return assign(new CreateMallVoucherDto(), {
      productType: 'physical'
    })
  }
}

export class FindMallVoucherDto extends PagingDto {
  status?: string
  searchText?: string
  mallId?: string
  getAll?: boolean
  source?: MallCouponSource
}

export class ExportHistoryDto {
  startDate?: Date
  endDate?: Date
  email?: string
  source?: MallCouponSource
}

export class MallVoucherDto extends BaseDto {
  title: string
  khmerTitle: string
  englishTitle: string
  amount: number
  limitUsage: number
  discountType: string
  endDate: Date
  givenType: string
  voucherCode: string
  enabled: boolean
  creator: UserDto
  type: string
  tenantId: string
  productType?: string

  static create() {
    return new MallVoucherDto()
  }
}

export class MallVoucherDetailDto extends BaseDto {
  khmerTitle: string
  englishTitle: string
  amount: number
  limitUsage: number
  discountType: string
  startDate: DateOfBirthDto
  endDate: DateOfBirthDto
  minOrder: number
  maxOrder: number
  givenType: string
  ownerIds: string[]
  type: string
  tenantId: string
  minTenant: number
  maxTenant: number
  productType?: string

  static create() {
    return assign(new MallVoucherDetailDto(), {
      maxOrder: 1999.99,
      productType: 'physical'
    })
  }
}

export class VoucherHistoryDto extends BaseDto {
  owner: UserDto
  total: number
  voucherTotal: number
  voucherDiscountAmount: number
  voucherDiscountType: string
  mallOrder: MallOrderDto
  mallVoucher: MallVoucherDto

  static create() {
    return new VoucherHistoryDto()
  }
}